var map = {
	"./1v1_rt.png": "b557",
	"./1v1_tb.png": "b729",
	"./32_player.png": "89d0",
	"./codex/carrier1.png": "4675",
	"./codex/carrier2.png": "cae7",
	"./codex/eventlog1.png": "a449",
	"./codex/map1.png": "7d10",
	"./codex/research1.png": "8a26",
	"./codex/star1.png": "c2c8",
	"./codex/star2.png": "357f",
	"./codex/star3.png": "e80c",
	"./codex/star4.png": "d209",
	"./codex/star5.png": "af29",
	"./featured.png": "2099",
	"./game-carousel-1.png": "9d05",
	"./game-carousel-2.png": "256d",
	"./game-carousel-3.png": "2199",
	"./game1.png": "b186",
	"./home-1.png": "fe6b",
	"./home-2.png": "5d2c",
	"./home-3.png": "f141",
	"./home-4.png": "b7ab",
	"./home-5.png": "26c4",
	"./new_player_rt.png": "7bd4",
	"./special_anonymous.png": "5e7d",
	"./special_arcade.png": "ddba",
	"./special_battleRoyale.png": "cb89",
	"./special_dark.png": "5f15",
	"./special_fog.png": "f30c",
	"./special_freeForAll.png": "73e5",
	"./special_homeStar.png": "556f",
	"./special_homeStarElimination.png": "6874",
	"./special_kingOfTheHill.png": "e55d",
	"./special_orbital.png": "1965",
	"./special_tinyGalaxy.png": "cd29",
	"./special_ultraDark.png": "37f5",
	"./standard_rt.png": "49ac",
	"./standard_tb.png": "a184",
	"./tutorial.png": "5943"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0cf8";